import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useBank() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/bank/")
    .then((res: SuccessFetch<{
      payload: {
        bank_id: number
        bank_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.bank_name, value: item.bank_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/bank/")
    .then((res: SuccessFetch<{
      payload: {
        bank_id: number
        bank_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.bank_name, value: item.bank_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}